export enum FittingSideType {
    None = 0,
    Vorne = 1,
    Hinten = 2,
    Links = 16,
    Rechts = 32,

    VorneLinks = Vorne | Links,
    VorneRechts = Vorne | Rechts,
    HintenLinks = Hinten | Links,
    HintenRechts = Hinten | Rechts,
    VorneHintenLinks = Vorne | Hinten | Links,
    VorneHintenRechts = Vorne | Hinten | Rechts,
}

export enum ArticleListViewOptionsType {
    Undefined = 0,
    Compact = 1,
    Detailed = 2,
    Images = 4,
}

export interface SearchStepDto {
    processId: string
    number: number
}

export interface PagingDto {
    /**
     * @property [optional] The Page Index.
     */
    pageIndex?: number

    /**
     * @property [optional] The Page Size.
     */
    pageSize?: number

    /**
     * @property [optional] The Page Index of the last page.
     */
    pageIndexMax?: number
}
